import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import FAQ from '../../components/HowItWorks/FAQ';
import HeroSection from '../../components/HowItWorks/HeroSection';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { index } from '../../components/HowItWorks/AccordionContent';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:headerTitle.aboutUs',
    title: 'howItWorks:thisIsVirpp',
    subtitle: 'howItWorks:howItWorksDescriptions.thisIsVirpp',
    media: 'https://www.youtube-nocookie.com/embed/lxAZ2IPGuKE',
    leftColumn: '7',
    rightColumn: '5',
    picture: false,
    videoLeft: false,
    button: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:headerTitle.use',
    title: 'howItWorks:getStarted',
    subtitle: 'howItWorks:howItWorksDescriptions.gettingStarted',
    media: '/static/animations/account.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
    button: true,
    buttonLink: '/how-it-works/how-to-use',
  },
  {
    key: 3,
    headerTitle: 'howItWorks:headerTitle.howToUpload',
    title: 'howItWorks:howToUpload',
    subtitle: 'howItWorks:howItWorksDescriptions.howToUpload',
    media: '/static/animations/uploading.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
    button: true,
    buttonLink: '/how-it-works/how-to-upload',
  },
  {
    key: 4,
    headerTitle: 'howItWorks:headerTitle.feedbackReq',
    title: 'howItWorks:howToFeedback',
    subtitle: 'howItWorks:howItWorksDescriptions.gettingFeedback',
    media: '/static/animations/feedback.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
    button: true,
    buttonLink: '/how-it-works/get-feedback',
  },
  {
    key: 5,
    headerTitle: 'howItWorks:headerTitle.connect',
    title: 'howItWorks:howToContests',
    subtitle: 'howItWorks:howItWorksDescriptions.joinContests',
    media: '/static/animations/win.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
    button: true,
    buttonLink: '/how-it-works/join-contests',
  },
  {
    key: 6,
    headerTitle: 'howItWorks:headerTitle.getInsights',
    title: 'howItWorks:stats',
    subtitle: 'howItWorks:howItWorksDescriptions.statistics',
    media: '/static/animations/stats.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
    button: true,
    buttonLink: '/how-it-works/statistics',
  },
  {
    key: 7,
    headerTitle: 'howItWorks:headerTitle.distribution',
    title: 'howItWorks:howToReleased',
    subtitle: 'howItWorks:howItWorksDescriptions.requestRelease',
    media: '/static/animations/release.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
    button: true,
    buttonLink: '/how-it-works/releasing-music',
  },
  {
    key: 8,
    headerTitle: 'howItWorks:headerTitle.wallet',
    title: 'howItWorks:vcoins',
    subtitle: 'howItWorks:howItWorksDescriptions.whatAreVcoins',
    media: '/static/animations/coin.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
    button: true,
    buttonLink: '/how-it-works/what-are-vcoins',
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>{t('howItWorks:howItWorks')}</BrowserPageTitle>
      <Container fluid className="d-flex align-items-center position-relative">
        <HeroSection />
      </Container>

      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            picture={howTo.picture}
            subtitle={howTo.subtitle}
            media={howTo.media}
            button={howTo.button}
            buttonLink={howTo.buttonLink}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            button={howTo.button}
            buttonLink={howTo.buttonLink}
          />
        ),
      )}

      <FAQ page={index} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works',
  });
  return { ...getTranslations };
};

export default Index;
